import ActionTypes from './ActionTypes';

const getSubscriptions = payload => {
    return{
        type: ActionTypes.GET_SUBSCRIPTIONS,
        payload,
    }
}

const getPaymentCards = payload => {
    return{
        type: ActionTypes.GET_PAYMENT_CARDS,
        payload,
    }
}

const updatePaymentCards = payload => {
    return{
        type: ActionTypes.UPDATE_PAYMENT_CARDS,
        payload,
    }
}

const updateActiveCards = payload => {
    return{
        type: ActionTypes.UPDATE_ACTIVE_CARDS,
        payload,
    }
}


export { getSubscriptions , getPaymentCards , updatePaymentCards, updateActiveCards};